// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SiHaDocumentationModel from '../../model/si-ha-documentation-model';
import SiHaDocumentationDTO from '../dto/si-ha-documentation-dto';
import dtoSchema from '../schemas/si-ha-documentation-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SiHaDocumentationModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SiHaDocumentationDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.shareId = data.shareId;
      this.userId = data.userId;
      this.siHaDocumentationStatus = data.siHaDocumentationStatus;
      this.constructionPlanDocumentExternalId = data.constructionPlanDocumentExternalId ?? undefined;
      this.locationMapDocumentExternalId = data.locationMapDocumentExternalId ?? undefined;
      this.title = data.title ?? undefined;
      this.remark = data.remark ?? undefined;
      this.projectNumber = data.projectNumber ?? undefined;
      this.clientCompanyName = data.clientCompanyName ?? undefined;
      this.clientAddressLine = data.clientAddressLine ?? undefined;
      this.clientPostalCode = data.clientPostalCode ?? undefined;
      this.clientCity = data.clientCity ?? undefined;
      this.clientFirstName = data.clientFirstName ?? undefined;
      this.clientLastName = data.clientLastName ?? undefined;
      this.clientEMail = data.clientEMail ?? undefined;
      this.clientPhoneNumber = data.clientPhoneNumber ?? undefined;
      this.addressLine = data.addressLine ?? undefined;
      this.city = data.city ?? undefined;
      this.postalCode = data.postalCode ?? undefined;
      this.nextInspectionDueDate = data.nextInspectionDueDate ?? undefined;
      this.safetyHookIds = data.safetyHookIds ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {uuid}
  */
  shareId?: string;
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @type {int32}
  */
  siHaDocumentationStatus?: 1 | 2 | 3 | 4 | 5; // SiHaDocumentationStatusEnumDTO
  /**
  */
  constructionPlanDocumentExternalId?: string;
  /**
  */
  locationMapDocumentExternalId?: string;
  /**
  * @maximum 255
  */
  title?: string;
  /**
  */
  remark?: string;
  /**
  * @maximum 30
  */
  projectNumber?: string;
  /**
  * @maximum 255
  */
  clientCompanyName?: string;
  /**
  * @maximum 255
  */
  clientAddressLine?: string;
  /**
  * @maximum 10
  */
  clientPostalCode?: string;
  /**
  * @maximum 255
  */
  clientCity?: string;
  /**
  * @maximum 255
  */
  clientFirstName?: string;
  /**
  * @maximum 255
  */
  clientLastName?: string;
  /**
  * @maximum 255
  */
  clientEMail?: string;
  /**
  * @maximum 50
  */
  clientPhoneNumber?: string;
  /**
  * @maximum 255
  */
  addressLine?: string;
  /**
  * @maximum 255
  */
  city?: string;
  /**
  * @maximum 10
  */
  postalCode?: string;
  /**
  * @type {date-time}
  */
  nextInspectionDueDate?: string;
  /**
  */
  safetyHookIds?: number[];

  static toModel(dto: DeepPartial<SiHaDocumentationDTO>): SiHaDocumentationModel;
  static toModel(dto: DeepPartial<SiHaDocumentationDTO> | undefined | null): SiHaDocumentationModel | undefined;
  static toModel(dto: DeepPartial<SiHaDocumentationDTO> | undefined | null): SiHaDocumentationModel | undefined {
    return dto ? new SiHaDocumentationModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SiHaDocumentationModel> | SiHaDocumentationModel): SiHaDocumentationDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      shareId: unwrapped.shareId,
      userId: unwrapped.userId,
      siHaDocumentationStatus: unwrapped.siHaDocumentationStatus,
      constructionPlanDocumentExternalId: unwrapped.constructionPlanDocumentExternalId,
      locationMapDocumentExternalId: unwrapped.locationMapDocumentExternalId,
      title: unwrapped.title,
      remark: unwrapped.remark,
      projectNumber: unwrapped.projectNumber,
      clientCompanyName: unwrapped.clientCompanyName,
      clientAddressLine: unwrapped.clientAddressLine,
      clientPostalCode: unwrapped.clientPostalCode,
      clientCity: unwrapped.clientCity,
      clientFirstName: unwrapped.clientFirstName,
      clientLastName: unwrapped.clientLastName,
      clientEMail: unwrapped.clientEMail,
      clientPhoneNumber: unwrapped.clientPhoneNumber,
      addressLine: unwrapped.addressLine,
      city: unwrapped.city,
      postalCode: unwrapped.postalCode,
      nextInspectionDueDate: unwrapped.nextInspectionDueDate,
      safetyHookIds: unwrapped.safetyHookIds,
    } as SiHaDocumentationDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SiHaDocumentationModel, can not map to SiHaDocumentationDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
